import React from "react";
import {
  EmailInbox,
  EmailSettings,
  EmailTemplate,
} from "../../../Components/Private/Email";

export default function Email() {
  return (
  <main className="main">
    <div className="applicant-status-body email-tab">
      <div className="email-nav d-flex rounded overflow-hidden">
        <div
          className="nav-tab-list flex-md-column nav-pills"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <button
            className="email-items active"
            id="v-pills-compose-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-compose"
            type="button"
            role="tab"
            aria-controls="v-pills-compose"
            aria-selected="true"
          >
            <i className="bx bx-edit"></i>
          </button>
          <button
            className="email-items"
            id="v-pills-send-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-send"
            type="button"
            role="tab"
            aria-controls="v-pills-send"
            aria-selected="false"
          >
            <i className="bx bx-send"></i>
          </button>
          <button
            className="email-items"
            id="v-pills-settings-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-settings"
            type="button"
            role="tab"
            aria-controls="v-pills-settings"
            aria-selected="false"
          >
            <i className="bx bx-cog"></i>
          </button>
        </div>
        <div className="tab-content" id="v-pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="v-pills-compose"
            role="tabpanel"
            aria-labelledby="v-pills-compose-tab"
            tabIndex="0"
          >
            <EmailTemplate />
          </div>
          <div
            className="tab-pane fade"
            id="v-pills-inbox"
            role="tabpanel"
            aria-labelledby="v-pills-inbox-tab"
            tabIndex="0"
          >
            Inbox
          </div>
          <div
            className="tab-pane fade"
            id="v-pills-send"
            role="tabpanel"
            aria-labelledby="v-pills-send-tab"
            tabIndex="0"
          >
            <EmailInbox />
          </div>
          <div
            className="tab-pane fade"
            id="v-pills-document"
            role="tabpanel"
            aria-labelledby="v-pills-document-tab"
            tabIndex="0"
          >
            Document
          </div>
          <div
            className="tab-pane fade"
            id="v-pills-heart"
            role="tabpanel"
            aria-labelledby="v-pills-heart-tab"
            tabIndex="0"
          >
            Heart
          </div>
          <div
            className="tab-pane fade"
            id="v-pills-settings"
            role="tabpanel"
            aria-labelledby="v-pills-settings-tab"
            tabIndex="0"
          >
            <EmailSettings />
          </div>
        </div>
      </div>
    </div>
    </main>
  );
}
